import { CoreContext } from "context/CoreContext";
import React, { useContext, useEffect, useState } from "react";  
import { useHistory } from "react-router-dom";
import { parseCategory } from "utils/parser";

import {    
    MenuScroll, 
    BodyMenu,
    BodyMenuItem,
    MenuMenu,
    MenuItem
} from "./styled"; 

export default function DashboardMenu({ tabs, mode = 'learning' }) {  

    const history = useHistory();
    const navigate = to => {
        console.log("Navegando para:", to); // Rastreando a navegação
        history.push(`/${to}`);
    };

    const [opened, setOpened] = useState(''); 
    const { currentCategory, setCurrentCategory } = useContext(CoreContext);

    const action = (e, item, key) => {
        console.log("Ação em:", item.title, "Modo:", mode); // Rastreando ação de clique
        if(item.options){
            if(!e.target.closest('.menu-menu')){
                setOpened(opened === item.title ? '' : item.title);
            }
        } else { 
            console.log("Mudando a categoria atual para:", key); // Log para categoria atual
            setCurrentCategory(key);
            menuAction(item, key); // Chama menuAction diretamente
        }
    };   

    const menuAction = (item, key) => {  
        let path = '';
        
        console.log("Menu Action para:", item.title, "Modo:", mode);
        
        // Determina o caminho baseado no título da categoria
        if (mode === 'learning') {
            // Modo aprendizado - mapeia pelo título da categoria
            switch(item.title) {
                case 'ChatBox':
                    path = 'dashboard/chatbox'; // ChatBox original (Salomão)
                    break;
                case 'ChatBox02':
                    path = 'dashboard/chatbox02'; // ChatBox02 (Daniel)
                    break;
                case 'ChatBox03':
                    path = 'dashboard/chatbox03'; // ChatBox03 (Ester)
                    break;
                case 'ChatBox04':
                    path = 'dashboard/chatbox04'; // ChatBox04 (Davi)
                    break;
                default:
                    path = 'dashboard/chatbox';
            }
        } else if (mode === 'conversation') {
            // Modo conversa livre - mapeia pelo título da categoria
            switch(item.title) {
                case 'ChatBox05':
                    path = 'dashboard/chatbox05'; // ChatBox05 - Baseado no Salomão
                    break;
                case 'ChatBox06':
                    path = 'dashboard/chatbox06'; // ChatBox06 - Baseado no Daniel
                    break;
                case 'ChatBox07':
                    path = 'dashboard/chatbox07'; // ChatBox07 - Baseado na Ester
                    break;
                case 'ChatBox08':
                    path = 'dashboard/chatbox08'; // ChatBox08 - Baseado no Davi
                    break;
                default:
                    path = 'dashboard/chatbox05';
            }
        } else {
            // Fallback para modo padrão
            path = `dashboard/${item.title.toLowerCase()}`;
        }
        
        console.log("Navegando para:", path);
        navigate(path);
        setOpened('');
    };

    const [categories, setCategories] = useState([]); // Inicializando como um array vazio
    
    const init = () => {
        if(tabs?.length){
            const homeTabs = [
                ...tabs.slice(0, 10).map(parseCategory) // Mantém apenas as tabs
            ];
            
            setCategories(homeTabs);
            console.log("Categorias inicializadas:", homeTabs, "Modo:", mode); // Rastreando as categorias
        } else {
            console.log("Nenhuma tab encontrada para o modo:", mode); // Rastreando caso não haja tabs
        }
    };

    useEffect(() => {
        init();
    }, [tabs, mode]);

    return ( 
        <> 
            <MenuScroll>
                <BodyMenu>
                    {
                        categories.map((item, key) => 
                            <BodyMenuItem key={key} active={key === currentCategory} onClick={e => action(e, item, key)} >
                                <img src={item.image} alt={item.title} style={{ width: '100%', height: 'auto' }} /> {/* Exibindo imagem */}
                                {/*{item.title} {/* Exibindo título se necessário */}
                                {
                                    opened === item.title ? <>
                                        <MenuMenu className="menu-menu">
                                            {
                                                (tabs?.length > 3 ? [...tabs].slice(3).map(parseCategory) : [])?.map((mit, mik) => 
                                                    <MenuItem key={`${key}-${mik}`} onClick={() => {
                                                        console.log("Clique na subcategoria:", mit.title); // Rastreando clique na subcategoria
                                                        menuAction(mit, mik + 3);
                                                    }}>
                                                        <img src={mit.image} alt={mit.title} style={{ width: '30px', height: '30px', marginRight: '5px' }} /> {/* Exibindo imagem nas opções */}
                                                        {mit.title}
                                                    </MenuItem>
                                                )
                                            }
                                        </MenuMenu>
                                    </> : null
                                }
                            </BodyMenuItem>
                        )
                    }
                </BodyMenu> 
            </MenuScroll> 
        </>
    );
}
